import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import TrustSection from './components/TrustSection';
import ProcessSection from './components/ProcessSection';
import AreasSection from './components/AreasSection';
import TestimonialsSection from './components/TestimonialsSection';
import CtaSection from './components/CtaSection';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import CookieBanner from '../../components/feature/CookieBanner';

export default function HomePage() {
  useEffect(() => {
    document.title = 'JUSTCLEAN VIC - Vaciado de Pisos y Locales en Vic | Servicio Profesional';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Vaciado de pisos y locales en Vic y Osona. Limpieza síndrome de Diógenes, retirada de muebles. Servicio 24h. ☎️ 602 36 59 96 | Presupuesto sin compromiso'
      );
    }

    // Add LocalBusiness Schema
    const localBusinessScript = document.createElement('script');
    localBusinessScript.type = 'application/ld+json';
    localBusinessScript.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'JUSTCLEAN VIC',
      image: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/vite.svg`,
      '@id': import.meta.env.VITE_SITE_URL || 'https://example.com',
      url: import.meta.env.VITE_SITE_URL || 'https://example.com',
      telephone: '+34602365996',
      email: 'info@vic.justclean.es',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Carrer de Jacint Verdaguer, 15',
        addressLocality: 'Vic',
        postalCode: '08500',
        addressRegion: 'Barcelona',
        addressCountry: 'ES',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 41.9304,
        longitude: 2.2553,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '20:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Saturday',
          opens: '09:00',
          closes: '14:00',
        },
      ],
      priceRange: '$$',
      areaServed: [
        { '@type': 'City', name: 'Vic' },
        { '@type': 'City', name: 'Manlleu' },
        { '@type': 'City', name: 'Torelló' },
        { '@type': 'City', name: 'Taradell' },
      ],
    });
    document.head.appendChild(localBusinessScript);

    // Add Service Schema
    const serviceScript = document.createElement('script');
    serviceScript.type = 'application/ld+json';
    serviceScript.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Vaciado de Pisos y Locales',
      provider: {
        '@type': 'LocalBusiness',
        name: 'JUSTCLEAN VIC',
        telephone: '+34602365996',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Vic',
          addressRegion: 'Barcelona',
          addressCountry: 'ES',
        },
      },
      areaServed: {
        '@type': 'State',
        name: 'Barcelona',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Servicios de Vaciado y Limpieza',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Vaciado de Pisos',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Vaciado de Locales',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Limpieza Síndrome de Diógenes',
            },
          },
        ],
      },
    });
    document.head.appendChild(serviceScript);

    return () => {
      document.head.removeChild(localBusinessScript);
      document.head.removeChild(serviceScript);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <TrustSection />
        <ProcessSection />
        <AreasSection />
        <TestimonialsSection />
        <CtaSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
      <CookieBanner />
    </div>
  );
}
